import * as React from "react";
import { useCallback } from "react";
import { Field } from "formik";
import { Select } from "components/common";
const _capabilitiesOptions = (capabilities) => capabilities.map((capability) => ({ label: capability.title, value: capability.id })).toJS();
const CapabilitySelect = ({ capabilities, onChange = null, title = "Select a capability", ...rest }) => {
  const capabilitiesOptions = _capabilitiesOptions(capabilities);
  const handleChange = useCallback(
    (name, capabilityId, onFieldChange) => {
      onFieldChange({ target: { value: capabilityId, name } });
      if (typeof onChange === "function") {
        onChange(capabilityId);
      }
    },
    [onChange]
  );
  return /* @__PURE__ */ React.createElement(Field, { name: "capabilityId" }, ({ field: { name, value, onChange: onFieldChange } }) => /* @__PURE__ */ React.createElement(
    Select,
    {
      ...rest,
      clearable: false,
      onChange: (capabilityId) => handleChange(name, capabilityId, onFieldChange),
      options: capabilitiesOptions,
      placeholder: title,
      value
    }
  ));
};
export default CapabilitySelect;
